<template>
<!-- Trip Filter Title -->
    <div class="overlay-title mb-4 flex items-center gap-2">
    <svg class="w-4 h-4 text-grey-dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">...</svg>
    <strong class="text-base text-grey-darkest">Trip Filters</strong>
    </div>

    <!-- Filter Bar -->
    <div class="w-full flex flex-col gap-4 md:flex-row md:flex-wrap md:items-end md:gap-x-6 md:gap-y-4">
    
    <!-- Brand -->
    <div v-if="BrandFilter.length > 0" class="flex-none w-full md:w-[16rem] px-2 ml-1 md:px-0">
      <label class="block text-xs text-grey-darkest font-medium mb-1 " for="brand-filter">Brand</label>
      <select
        id="brand-filter"
        v-model="selectedBrand"
        class="w-full border border-grey-light rounded px-3 py-2 text-sm text-grey-dark bg-white"
        @change="StrictFilterChange()"
      >
        <option value="">All Brands</option>
        <option v-for="brand in BrandFilter" :key="brand" :value="brand">{{ brand }}</option>
      </select>
    </div>

    <!-- Departure -->
    <div v-if="DepartureFilter.length > 0" class="flex-none w-full md:w-[14rem] px-2 md:px-0">
      <label class="block text-xs text-grey-darkest font-medium mb-1" for="brand-departure">Departure</label>
      <select
        id="brand-departure"
        v-model="selectedDeparture"
        class="w-full border border-grey-light rounded px-3 py-2 text-sm text-grey-dark bg-white"
        @change="StrictFilterChange()"
      >
        <option value="">All Departures</option>
        <option v-for="departure in DepartureFilter" :key="departure" :value="departure">{{ departure }}</option>
      </select>
    </div>

    <!-- Duration -->
    <div v-if="DurationFilter.length > 0" class="flex-none w-full md:w-[14rem] px-2 md:px-0">
      <label class="block text-xs text-grey-darkest font-medium mb-1" for="brand-duration">Duration</label>
      <select
        id="brand-duration"
        v-model="selectedDuration"
        class="w-full border border-grey-light rounded px-3 py-2 text-sm text-grey-dark bg-white"
        @change="StrictFilterChange()"
      >
        <option value="">All Durations</option>
        <option v-for="duration in DurationFilter" :key="duration" :value="duration">{{ duration }}</option>
      </select>
    </div>

    <!-- Sort By -->
    <div class="flex-none w-full md:w-[14rem] px-2 md:px-0">
      <label class="block text-xs text-grey-darkest font-medium mb-1" for="sort-filter">Sort By</label>
      <select
        id="sort-filter"
        v-model="selectedSort"
        class="w-full border border-grey-light rounded px-3 py-2 text-sm text-grey-dark bg-white"
        @change="StrictFilterChange()"
      >
        <option value="default">Default</option>
        <option value="price_desc">Price: High to Low</option>
        <option value="price_asc">Price: Low to High</option>
        <option value="duration_desc">Longest</option>
        <option value="duration_asc">Shortest</option>
        <option value="alphabetical_desc">A-Z</option>
        <!-- <option value="alphabetical_asc">Z-A</option> -->
      </select>
    </div>

    
  </div>
    <!-- Clear Filters -->
    <div v-if="showClearFiltersButton()" class="w-full flex justify-start px-2 ml-1 md:px-0">
        <div class="flex-none w-full md:w-auto md:ml-0 md:text-left text-left">
            <button
                class="text-sm bg-grey-lighter text-grey-darkest hover:bg-grey-lightest mt-1 px-3 py-1 rounded border border-grey-light"

                @click="clearFilters()"
                type="button"
            >
                Clear Filters
            </button>
        </div>
    </div>
</template>

<script lang="ts" src="./strict_filters.ts"></script>
